export default __webpack_public_path__ + "static/media/zw.e7262899.svg";